const Checkout = () => import(/* webpackChunkName: "checkout" */ './Checkout');

export default {
  path: '/purchase/checkout',
  component: Checkout,
  name: 'checkout',
};